<script>
import {ref, onMounted, onUnmounted} from "vue";
import IconArrowUp from "@js/components/Icons/IconArrowUp.vue";

export default {
    name: "ScrollUp",
    components: {IconArrowUp},
    setup() {
        const showButton = ref(false);

        let scrollToTop = () => {}
        if (typeof window !== "undefined") {
            const handleScroll = () => {
                showButton.value = window.scrollY > 300; // Показываем кнопку, если проскроллено 300px
            };

            scrollToTop = () => {
                window.scrollTo({top: 0, behavior: "smooth"});
            };

            onMounted(() => {
                window.addEventListener("scroll", handleScroll);
            });

            onUnmounted(() => {
                window.removeEventListener("scroll", handleScroll);
            });
        }

        return {showButton, scrollToTop};
    },
};
</script>

<template>
    <transition name="fade">
        <button v-if="showButton" @click="scrollToTop" type="button"
                class="fixed start-6 bottom-6 z-50 flex items-center justify-center text-white bg-indigo-600 rounded-full w-14 h-14 hover:bg-indigo-800 focus:outline-none transition-all shadow-lg">
            <IconArrowUp class="w-7 h-7 stroke-white transition-transform"/>
        </button>
    </transition>
</template>

<style scoped>
/* Анимация появления кнопки */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
